import type { ReactNode } from 'react';
import { GoogleAnalytics } from './google';
import { PostHogProvider } from './posthog/client';
import { VercelAnalytics } from './vercel';

type AnalyticsProviderProps = {
  readonly children: ReactNode;
};

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  const isProduction = process.env.NODE_ENV !== 'development';
  const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

  return (
    <>
      {isProduction ? <PostHogProvider>{children}</PostHogProvider> : children}
      <VercelAnalytics />
      {isProduction && gaMeasurementId && (
        <GoogleAnalytics gaId={gaMeasurementId} />
      )}
    </>
  );
};
